import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=48c4473c"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"
import style0 from "./TextareaInput.vue?vue&type=style&index=0&id=48c4473c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports